import React, { Component } from 'react';

export default class BuyNowModalLoader extends Component {
    state = {
        Component: null,
        mounted: false,
    };

    componentDidMount() {
        return new Promise(resolve => {
            import(/* webpackChunkName: "BuyNowModal" */ './BuyNowModalContainer').then(mod => resolve(mod.default));
        }).then(container => {
            this.setState({ Component: container }, () => this.setState({ mounted: true }));
        });
    }
    componentWillUnmount() {
        this.setState({ mounted: false });
    }

    render() {
        const { Component, mounted } = this.state;
        return mounted && Component !== null ? <Component /> : null;
    }
}
